import React from 'react';
import Select from 'react-select';

/**
 * Keeps the subproject menu above the application header and gives its list a bounded viewport.
 * @param {Object} provided - Styles supplied by react-select for each rendered part.
 * @param {Object} state - Current react-select state for the styled part.
 * @returns {Object} Inline style overrides for the subproject selector.
 */
const searchSelectStyles = {
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 2000,
    }),
    menu: (provided) => ({
        ...provided,
        marginTop: 4,
        overflow: 'hidden',
        borderRadius: 6,
        boxShadow: '0 8px 20px rgba(18, 41, 77, 0.24)',
    }),
    menuList: (provided) => ({
        ...provided,
        maxHeight: 320,
        paddingTop: 4,
        paddingBottom: 4,
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#1479e9' : state.isFocused ? '#edf4fd' : '#fff',
        color: state.isSelected ? '#fff' : '#253b5f',
        cursor: 'pointer',
        padding: '9px 12px',
    }),
};

const SearchSelect = ({ listItems, itemSelected, loading = false, onChangeValue }) => {
    return (
        <div data-testid="my-searchSelect-component">
            {listItems && listItems.length > 0 ? (
                <Select
                    className="form-control searchSelect basic-single"
                    name="projects"
                    classNamePrefix="select"
                    defaultValue={
                        listItems.find((v) => v.value === itemSelected) ||
                        listItems[0] || {
                            value: 'loading',
                            label: 'loading',
                        }
                    }
                    isLoading={loading}
                    isRtl={false}
                    isSearchable
                    menuPosition="fixed"
                    menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                    maxMenuHeight={320}
                    styles={searchSelectStyles}
                    onChange={(v) => {
                        onChangeValue(v && v.value);
                    }}
                    options={listItems}
                />
            ) : (
                <div />
            )}
        </div>
    );
};

export default SearchSelect;
